import { createSelector } from '@reduxjs/toolkit'

import { selectMdfActivitiesState } from './selectMdfActivitiesState'

export const selectMdfActivities = createSelector(
  [selectMdfActivitiesState],
  (state) => state.records
)
